var map = {
	"./en.json": 412,
	"./fi.json": 413,
	"./sv.json": 414
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 411;


//////////////////
// WEBPACK FOOTER
// ./src/i18n ^\.\/.*\.json$
// module id = 411
// module chunks = 0